const Footer = ()=>{
    return(
        <footer className="text-center text-lg-start bg-dark text-muted mt-4">
            <div className="text-center p-4">
                Made With <i className="fa-solid fa-heart"></i> by Manuel Bautista <br></br>
                <a className="text-reset fw-bold" href="https://manuelbautista.netlify.app/">My Online Portfolio</a>
            </div>
        </footer>
    )
}

export default Footer